import React, { SVGProps } from 'react';
import { COLOR_PALETTE } from 'app/constants/ColorPalette';

interface IProps extends SVGProps<SVGSVGElement> {
  color?: string;
  backgroundColor?: string;
}

/* eslint-disable max-len */
const SvgEraser: React.FunctionComponent<IProps> = ({
  color = COLOR_PALETTE.grey.darker,
  backgroundColor = COLOR_PALETTE.grey.white,
  ...props
}) => (
  <svg viewBox="0 0 1590 1590" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill={backgroundColor} cx={795} cy={795} r={795} />
      <rect fill={color} x={422} y={1084} width={748} height={75} rx={17} />
      <path
        d="M926.35 450.5L1130 654.15c30.8 30.87 30.82 80.86.03 111.75l-275.18 275.51c-6.7 3.15-12.52 4.72-17.48 4.72h-9.79c-44.59 0-223.67-.02-227.3 0-4.19.02-9.24-2.25-15.14-6.82l-123.9-123.54c-30.9-30.8-30.97-80.82-.16-111.72l.08-.08L814.63 450.5c30.85-30.85 80.87-30.85 111.72 0zM721 651.73l-209.3 209.3 111.59 111.6 194.72.7 112.3-112.3L721 651.73z"
        fill={color}
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgEraser;
